import React from 'react';
import {JourneyInfoHead} from './JourneyInfoHead/JourneyInfoHead';
import {ClearInfo} from './ClearInfo/ClearInfo';


 function Clear () {
  return (
    <div className="JourneyInfo">

      <JourneyInfoHead />

      <ClearInfo />

      
              
    </div>
  );
}

export default Clear;